import angular from 'angular';

import component from './when.component';

const ExperienceWhen = angular
    .module('control-room.experience-promoter.components.experience-manage.components.when', [])
    .component('crExperienceWhen', component);

export default ExperienceWhen;
